export { default } from './FilterPlaceholderCDS';
